module.exports = __webpack_public_path__ + "static/media/Engpic6@3x.01874126.png";